import { ClassAttributes, createElement, FC, ReactNode } from 'react';

export type Props = ClassAttributes<HTMLElement> & {
  href?: string;
  className?: string;
  children: ReactNode;
};

const Item: FC<Props> = () => <span />;

export default Item;
